import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth'
import logs from './modules/logs'
import messages from './modules/messages'
import language from './modules/language'
import api from '@/api'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    language,
    messages,
    auth,
    logs
  },
  state: {
    loading: false,
    title: null,
    tasks: [],
    actions: [],
    epp_services: [],
    epp_extensions: [],
  },
  getters: {
    isLoading(state) {
      return state.loading
    },
    pageTitle(state) {
      return state.title
    },
    localTasks(state) {
      return state.tasks
    },
    localActions(state) {
      return state.actions
    },
    eppExtensions(state) {
      return state.epp_extensions
    },
    eppServices(state) {
      return state.epp_services
    },
    // https://stackoverflow.com/a/50593278/11493911
    user: (state, getters) => () => {
      let user = {
        id: getters['auth/getUserId'],
        authed: getters['auth/isAuthed'],
        roles: getters['auth/isAdmin'] ? ['admin'] : [],
        epp_services: getters.eppServices,
        epp_extensions: getters.eppExtensions,
      };

      if (getters['auth/onloadAuthAttempted'] === false) {
        if (localStorage.getItem('user_object') === null) {
          return user
        }
        api.setSession(localStorage.getItem('epp_session_token_header'), localStorage.getItem('epp_session_token_value'));
        return JSON.parse(localStorage.user_object)
      } else {
        localStorage.setItem('user_object', JSON.stringify(user));
      }

      return user
    },
  },
  mutations: {
    setLoading(state, data) {
      Vue.set(state, 'loading', data)
    },

    setPageTitle(state, title) {
      if (typeof title !== "string" || title === "") {
        title = null
      }
      Vue.set(state, 'title', title)
    },

    setLocalTasks(state, tasks) {
      if (tasks === null || tasks instanceof Array === false) {
        Vue.set(state, 'tasks', [])
      } else {
        Vue.set(state, 'tasks', tasks)
      }
    },

    setLocalActions(state, actions) {
      if (actions === null || actions instanceof Array === false) {
        Vue.set(state, 'actions', [])
      } else {
        Vue.set(state, 'actions', actions)
      }
    },

    setEppServices(state, services) {
      Vue.set(state, 'epp_services', services)
    },

    setEppExtensions(state, exts) {
      Vue.set(state, 'epp_extensions', exts)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js